
      window["APP_BUILD_INFO"] ||= {};
      window["APP_BUILD_INFO"]["contact-us"] = {"build_base_commit_hash":"3816e11bec9dad653cb97c774721dc00f76909b7","build_branch":"release_train_1194349608194","build_pub_date":"2026-07-28 16:49:45","build_version":"2.0.0.712"};
    